import axios from "axios";
import { API_CONFIG } from "../config/api";
import { ProfitLossResponse, ExpenseSummaryResponse } from "../types/reports";

class ReportsService {
    private getAuthHeader() {
        const token = localStorage.getItem("access_token");
        return { headers: { Authorization: `Bearer ${token}` } };
    }

    async getProfitLoss(
        dateFrom?: string,
        dateTo?: string,
    ): Promise<ProfitLossResponse> {
        const params: Record<string, string> = {};
        if (dateFrom) params.date_from = dateFrom;
        if (dateTo) params.date_to = dateTo;

        const response = await axios.get(
            `${API_CONFIG.BASE_URL}/reports/profit-loss`,
            { params, ...this.getAuthHeader() },
        );
        return response.data;
    }

    async getExpenseSummary(
        dateFrom?: string,
        dateTo?: string,
    ): Promise<ExpenseSummaryResponse> {
        const params: Record<string, string> = {};
        if (dateFrom) params.date_from = dateFrom;
        if (dateTo) params.date_to = dateTo;

        const response = await axios.get(
            `${API_CONFIG.BASE_URL}/reports/expense-summary`,
            { params, ...this.getAuthHeader() },
        );
        return response.data;
    }
}

export const reportsService = new ReportsService();
